import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const ContentTitle = styled.div`
  padding: 16px 0;
  font-size: 23px;
  color: ${colors.grey7};
  border-bottom: 1px solid ${colors.grey2};
`;

export const Section = styled.div`
  display: flex;
  padding: 32px 0;
  border-bottom: 1px solid ${colors.grey2};
`;
export const SectionText = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
`;
export const SectionTitle = styled.div`
  font-size: 19px;
  line-height: 27px;
  color: ${colors.grey7};
  margin-bottom: 8px;
`;
export const SectionDescription = styled.div`
  font-size: 13px;
  color: ${colors.grey6};
  line-height: 19px;
`;
export const SectionForm = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 32px;
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 240px;
  margin-bottom: 20px;
`;
export const SelectLabel = styled.div`
  font-size: 13px;
  color: ${colors.grey5};
  margin-bottom: 4px;
  line-height: 19px;
  letter-spacing: 0.8px;
`;

export const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const RadioLabel = styled.div`
  font-size: 16px;
  color: ${colors.grey7};
  letter-spacing: 0.3px;
  margin-right: 8px;
  display: flex;
  align-items: center;
`;
